import React from 'react';

export default class Adcopy extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.ref.current.listing = this.props.listing;
  }

  render() {
    return (
      <sh-adcopy ref={this.ref}></sh-adcopy>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/listing-detail/sh-wrappers/adcopy.js